import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	Container,
	Paper,
	Typography,
	TextField,
	InputLabel,
	Button,
} from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import {
	useGetMonthlyDownloadsQuery,
	useGetStatsQuery,
} from '../../../store/apiSlice';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	backButton: {
		marginBottom: theme.spacing(2),
	},
}));

export function MonthlyDownloads(props) {
	const classes = useStyles();

	const [year, setYear] = useState(2024);
	const [query, setQuery] = useState(year);
	const { data, isFetching } = useGetMonthlyDownloadsQuery(query);

	const handleSearch = () => {
		setQuery(year);
	};
	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Статистика</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Статистика
					</Typography>

					<div>
						<TextField
							value={year}
							type="number"
							className={classes.title}
							onChange={(e) => {
								e.persist();
								setYear((prevState) => {
									const newValue = parseInt(e.target.value) || prevState;
									return Math.max(
										Math.min(newValue, new Date().getFullYear()),
										2000
									);
								});
							}}
							label="Година"
						></TextField>
						<br />
						<Button disabled={isFetching} onClick={handleSearch}>
							OK
						</Button>
					</div>
					<br></br>

					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell>Месец</TableCell>
									<TableCell>Брой</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{data?.byMonth?.map((data, i) => {
									const date = new Date(2024, i + 1, 0); // 2009-11-10
									const month = date.toLocaleString('BG-bg', { month: 'long' });
									return (
										<TableRow key={i}>
											<TableCell>{month}</TableCell>
											<TableCell>{data}</TableCell>
										</TableRow>
									);
								})}
								<TableRow>
									<TableCell>Общо</TableCell>
									<TableCell>{data?.total}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Paper>
			</Container>
		</div>
	);
}
